import React from "react";
import { Icons } from "../../../constants/icon-library";

const NotFoundMessage = ({ message, onAddNew, buttonMessage }) => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center p-6 bg-body-emphasis rounded-3 shadow-sm">
      <div className="text-center mb-4">
        <i className={`wb ${Icons('notfound')} fs-4`}></i>
        <h3 className="mb-2 text-body-secondary">{message}</h3>
        <p className="text-muted">
          You can create one by clicking the button below.
        </p>
      </div>
      <button className="btn btn-primary" onClick={onAddNew}>
        <i className={`wb ${Icons('notfound')} fs-9 me-2 mt-1 align-middle`}></i>
        {buttonMessage}
      </button>
    </div>
  );
};

export default NotFoundMessage;
